import { Reveal } from "@/components/Reveal";
import PhoneMockup from "@/components/PhoneMockup";
import { Star, Clock, Car, ShieldCheck } from "lucide-react";
import { useSiteConfig } from "@/context/SiteConfigContext";

const ROWS = [
  { icon: Car, label: "Provider", value: "Marcus T. · RapidRoad" },
  { icon: Star, label: "Rating", value: "4.9 (1,204 jobs)" },
  { icon: Clock, label: "ETA", value: "12 minutes" },
  { icon: ShieldCheck, label: "Vehicle", value: "White Ford F-150" },
];

export default function LiveService() {
  const { config } = useSiteConfig();
  const t = config.t.liveService;
  return (
    <section className="bg-white py-28 sm:py-36" data-testid="live-service-section">
      <div className="mx-auto grid max-w-6xl items-center gap-14 px-6 lg:grid-cols-2">
        <Reveal>
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-brand">{t.eyebrow}</p>
          <h2 className="mt-4 text-4xl font-bold tracking-tighter text-neutral-900 sm:text-5xl">
            {t.heading}
          </h2>
          <p className="mt-4 max-w-md text-lg text-neutral-500">{t.paragraph}</p>

          <div className="mt-8 space-y-3">
            {ROWS.map((r) => (
              <div key={r.label} className="flex items-center gap-4 rounded-2xl border border-black/5 bg-[#FAFAFC] px-5 py-4">
                <div className="grid h-10 w-10 place-items-center rounded-xl bg-brand/5 text-brand"><r.icon className="h-5 w-5" /></div>
                <div><p className="text-xs font-medium uppercase tracking-wide text-neutral-400">{r.label}</p><p className="text-[15px] font-semibold text-neutral-800">{r.value}</p></div>
              </div>
            ))}
          </div>

          <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-ai/10 px-4 py-2 text-sm font-semibold text-ai">
            <span className="relative flex h-2 w-2"><span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-ai opacity-75" /><span className="relative inline-flex h-2 w-2 rounded-full bg-ai" /></span>
            Current status: En route
          </div>
        </Reveal>

        <Reveal delay={0.1} className="flex justify-center">
          <div className="relative">
            <div className="brand-glow absolute inset-0 -z-10 scale-110" />
            <PhoneMockup screen="tracking" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
